// Module
var code = "<product-groups></product-groups>\n";
// Exports
module.exports = code;